import getTopics from 'services/apiHelpers/getTopics';
import getInteractionsInTopic from 'services/apiHelpers/getInteractionsInTopic';

const hasValidLocationUpdated = location => {
  if (!location) {
    return undefined;
  }

  if (['next', 'exit'].includes(location)) {
    return true;
  }
  //

  const [topicSId, interactionSId] = location.split('/');

  const topics = getTopics();
  const topic = topics.find((t: any) => {
    const tSId = t.props.sId || t.id;
    const found = tSId == topicSId;

    return found;
  });

  if (!topic) {
    return false;
  }

  const interactions = getInteractionsInTopic(topic);
  const interaction = interactions.find((i: any) => {
    const iSId = i.props.sId || i.id;
    const found = iSId == interactionSId;

    return found;
  });

  return interaction ? true : false;
};

export default hasValidLocationUpdated;
